import { type ThunkAction } from "redux-thunk";
import { type RootState } from "~/app/store";
import { type AnyAction } from "~/app/store/types";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import {
  type PushContextValues,
  trackLCAddToCart,
  trackLCSaveConfiguration,
  trackLCSimpleClick,
} from "~/features/configurator/common/configuratorGA";
import { getCurrentStep } from "~/features/configurator/Linear/redux/selectors";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackLCSimpleButtonAction(pushContext: PushContextValues, extra?: Dict<any>): ThunkResult<void> {
  return (dispatch, getState) => {
    const state = getState();
    const productCode = state.linearConfigurator.productCode;
    const step = getCurrentStep(state) + 1;
    trackLCSimpleClick(state, productCode, step, pushContext, extra);
  };
}

export function trackLCAddToCartAction(): ThunkResult<void> {
  return (dispatch, getState) => {
    const isQuote = userHasPermission(Permission.ADD_TO_QUOTE);

    if (isQuote) {
      return; // We only track add to cart, while this can trigger for both cart and quote
    }

    const state = getState();
    const productCode = state.linearConfigurator.productCode;
    const step = getCurrentStep(state);
    const designation = state.linearConfigurator.designation;
    const schaefflerId = state.linearConfigurator.schaefflerId;
    trackLCAddToCart(state, productCode, step, {
      productName: designation,
      schaefflerId,
    });
  };
}

export function trackLCSaveConfiguationAction(): ThunkResult<void> {
  return (dispatch, getState) => {
    const state = getState();
    const productCode = state.linearConfigurator.productCode;
    const step = getCurrentStep(state);
    const designation = state.linearConfigurator.designation;
    const schaefflerId = state.linearConfigurator.schaefflerId;
    trackLCSaveConfiguration(state, productCode, step, {
      productName: designation,
      schaefflerId,
    });
  };
}
